module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M17.6 12V0h-12v12h12zM16 1.6v8.8H7.2V1.6H16zM3.2 13.6H1.6V16H4v-1.6h-.8zM1.6 5.6h1.6v-.8H4V3.2H1.6zM12.8 14.4H12V16h2.4v-2.4h-1.6zM5.6 14.4h1.6V16H5.6zM8.8 14.4h1.6V16H8.8zM1.6 10.4h1.6V12H1.6zM1.6 7.2h1.6v1.6H1.6z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/fill_icon.svg
// module id = 703
// module chunks = 2